import { createContext } from "react";

export type StepChangeContextValue = [string, (value: string) => void];

export const StepChangeContext = createContext<StepChangeContextValue>([
  "",
  () => {}
]);
